import { css } from 'styled-components';
import {
  getSpacing, SpacingName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  $minimal,
}) => css`
  overflow-x: scroll;
  ${!$minimal && getSpacing.margin(theme, [SpacingName.ZERO, SpacingName.NEGATIVE_SMALLEST])}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    overflow-x: auto;
  }
`;

export const content = css`
  display: flex;
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  flex-shrink: 0;
  width: 7rem;
  ${getSpacing.padding(theme, [SpacingName.ZERO, SpacingName.SMALLEST])}
`;
